import { render, staticRenderFns } from "./DefaultRules.vue?vue&type=template&id=665b4aff&scoped=true&"
import script from "./DefaultRules.vue?vue&type=script&lang=js&"
export * from "./DefaultRules.vue?vue&type=script&lang=js&"
import style0 from "./DefaultRules.vue?vue&type=style&index=0&id=665b4aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665b4aff",
  null
  
)

export default component.exports